<!--
  author：Zoufx
  description：菜单
  date：2020/9/3
-->
<template>
    <el-container>
        <el-drawer title="菜单" :visible="formVisible" :before-close="handleClose" append-to-body :wrapperClosable="false"
                   @open="handleOpen">
            <div style="height: calc(100% - 63px);">
                <el-scrollbar class="drawer_scrollbar">
                    <el-row style="padding: 30px">
                        <el-form ref="form" :model="form" :rules="rules" label-width="90px">
                            <el-form-item label="上级菜单">
                                <!--                                <el-input v-model="form.parentMenuName" disabled size="medium"/>-->
                                <el-cascader :options="parentOptions"
                                             :props="{ checkStrictly: true }"
                                             filterable
                                             v-model="form.menuPid"
                                             :disabled="formState.parentDisabled"
                                             style="width: 100%"></el-cascader>
                            </el-form-item>
                            <el-form-item label="菜单名称" prop="menuName">
                                <el-input v-model="form.menuName" placeholder="请输入菜单名称" size="medium"/>
                            </el-form-item>
                            <el-form-item label="菜单类型" prop="category">
                                <el-radio v-model="form.category" label="1">菜单</el-radio>
                                <el-radio v-model="form.category" label="2">按钮</el-radio>
                            </el-form-item>
                            <el-form-item label="菜单路由">
                                <el-input v-model="form.menuPath" placeholder="请输入菜单路由" size="medium"/>
                            </el-form-item>
                            <el-form-item label="菜单组件">
                                <el-input v-model="form.menuComponent" placeholder="请输入菜单组件" size="medium"/>
                            </el-form-item>
                            <el-form-item label="菜单图标">
                                <el-input v-model="form.menuIconcls" placeholder="请输入菜单图标" size="medium"/>
                            </el-form-item>
                            <el-form-item label="排序" prop="sort">
                                <el-input-number v-model.number="form.sort" :min="0" :max="100" placeholder="请输入排序" size="medium"/>
                            </el-form-item>
                        </el-form>
                    </el-row>
                </el-scrollbar>
            </div>
            <el-row class="drawer_footer">
                <el-button type="primary" @click="submit" size="medium" :disabled="$store.state.loading">确 定</el-button>
                <el-button @click="handleClose" size="medium" :disabled="$store.state.loading">取 消</el-button>
            </el-row>
        </el-drawer>
    </el-container>
</template>

<script>

    export default {
        name: "SysMenuForm",
        props: ['formVisible', 'submitUrl', 'selData','formState'],
        data() {
            return {
                rules: {
                    menuName: [
                        {required: true, message: '请输入菜单名称', trigger: 'blur'}
                    ],
                    category: [
                        {required: true, message: '请选择菜单类型', trigger: 'blur'}
                    ],
                    orderNo: [
                        {type: 'number', message: '请输入数字', trigger: 'blur'}
                    ]
                },
                form: {},
                parentOptions: []
            }
        },
        mounted() {

        },
        methods: {
            async getParentOptions() {
                let {obj} = await this.postRequest('/sysMenu/findTree');
                this.parentOptions = obj;
            },
            handleOpen() {
                this.form = {...this.selData};
                this.getParentOptions();
            },
            handleClose() {
                this.$refs.form.clearValidate();
                this.form = {};
                this.$emit('update:formVisible', false);
            },
            async submit() {
                let valid = await this.$refs.form.validate().catch(() => {
                });
                if (!valid) return;
                let param = this.form;
                let pid = param.pid;
                if( Array.isArray(pid)){
                    param.pid = pid[pid.length - 1];
                }
                await this.postRequest(this.submitUrl, param);
                this.handleClose();
                this.$emit('refreshList');
            },
        }
    }
</script>

<style scoped>

</style>
